var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('InsideHeader',{attrs:{"title":_vm.pageData.title,"bredcrumb":_vm.breadcrumb}}),_c('About',{attrs:{"pagedata":_vm.pageData,"filepath":_vm.filePath}}),_c('Features')],1)}
var staticRenderFns = []

export { render, staticRenderFns }